import "./QuickReview.css";
import suman from "../../Images/ReviewImage/suman.png";
import star from "../../Images/Icons/star.png";
import paradise from "../../Images/ReviewImage/p1.png"

import imageLayer from "../../Images/BackgroundImg/ImageLayer.png";
const QuickReview = ()=>{
    return (
        <>
        <div className="quickReviewSec">
            <div className="quickBox">
                <div className="leftQuick">
                    <img src={paradise} alt="" />
                    <img src={paradise} alt="" />
                    <img src={paradise} alt="" />

                </div>

                <div className="rightQuick">
                    <div className="reviewTxt">“ His creative work consistently inspires newcomers, and his designs have a unique way of motivating others.”</div>
                    <div className="reviewProfile">
                        <div className="reviewPLeft">
                            <img src={paradise} alt=""/>
                        </div>
                        <div className="reviewPright">
                            <div className="stars">
                                <img src={star} alt=""/>
                                <img src={star} alt=""/>
                                <img src={star} alt=""/>
                                <img src={star} alt=""/>
                                <img src={star} alt=""/>
                            </div>
                            <div className="name">Paradise Migration Services</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}
export default QuickReview;